import React from 'react';

import BrandsDisplay from './Components/BrandsDisplay';

function Brand() {
    return (
        <>
            <div className="px-5 md:mx-auto md:max-w-1200">
                <div className="mt-5 flex w-full flex-col justify-start md:flex-row">
                    <div className="w-full">
                        <BrandsDisplay />
                    </div>
                </div>
            </div>
        </>
    );
}

export default Brand;
